import { C24LocationCardsProps } from './C24LocationCards.types';
import { LocationCards } from '@ahc-digital/component-library';
import { CreateLocationCardsModel } from './C24LocationCards.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C24LocationCardsProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <LocationCards
      {...CreateLocationCardsModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C24LocationCardsProps>(Default);
